import React, { useMemo } from "react";

import type { RatingsBreakdown as RatingsBreakdownType } from "@busbud/core-types/dist/lib/grand-central/api";
import Heading from "@busbud/design-system-components/dist/Heading";
import Label from "@busbud/design-system-components/dist/Label";
import Stack from "@busbud/design-system-components/dist/Stack";

import { useAppContext } from "@app/helpers/hooks";

import { RatingProgress } from "./rating-progress";

export const RatingsBreakdown = ({
  ratings_breakdown,
  global_rating,
  count_total
}: {
  ratings_breakdown: RatingsBreakdownType;
  global_rating: number;
  count_total: number;
}) => {
  const { translator } = useAppContext();

  const review_count_text = translator.t("!results.filters.operator-reviews", {
    ratings: count_total
  });

  const ratings = useMemo(() => {
    const rating_order = [5, 4, 3, 2, 1] as const;
    const ratings_brakdown_arr = rating_order.map(k => ratings_breakdown[k]);
    const total_ratings_count = ratings_brakdown_arr.reduce(
      (total, v) => total + v,
      0
    );
    return ratings_brakdown_arr.map((v, i) => ({
      star_count: rating_order[i],
      rating_count: v,
      rating_percentage: total_ratings_count > 0 ? v / total_ratings_count : 0
    }));
  }, [ratings_breakdown]);

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      flexWrap="wrap"
      spacing={2}
    >
      <Stack direction="column" alignItems="center">
        <Heading size="lg">{global_rating}</Heading>
        <Label size="xxs">{review_count_text}</Label>
      </Stack>
      <Stack direction="column" flexGrow={1}>
        {ratings.map(({ star_count, rating_count, rating_percentage }, i) => (
          <RatingProgress
            key={i}
            // @ts-expect-error TS2322 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
            star_count={star_count}
            rating_count={rating_count}
            rating_percentage={rating_percentage}
          />
        ))}
      </Stack>
    </Stack>
  );
};
